import { useMediaQuery } from '@ag1/ui';
import clsx from 'clsx';
import { StudioBaseImageV2 } from 'shared/studio/StudioBaseImage/StudioBaseImage';
import { ImageGrid as ImageGridProps, SanityKeyed } from 'types/studio/studio';
import { CommonSectionProps } from '../types';
import styles from './styles.module.scss';

const ImageGrid = ({
  images,
  visibleOnPageLoad
}: SanityKeyed<ImageGridProps> & CommonSectionProps) => {
  const atXSmall = useMediaQuery('xs');

  return (
    <div className={styles.gridWrapper}>
      <div className={styles.imageGrid}>
        {images.map((img, index) => (
          <div
            className={clsx(
              styles.imageLinkWrapper,
              img.imageSizeCategory && styles[img.imageSizeCategory]
            )}
            key={img._key}>
            <a
              className={styles.imageLink}
              href={img.linkUrl || undefined}
              target="_blank"
              aria-label="Opens in a new tab"
              rel="noopener noreferrer">
              <StudioBaseImageV2
                image={img.image}
                className={styles.img}
                aspectRatio={!atXSmall ? 2.5 : 1.5}
                sizes={{ xxs: '300px' }}
                eagerLoading={visibleOnPageLoad && index < 4}
              />
            </a>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ImageGrid;
